/**
 * @generated SignedSource<<97742d073c40f0aed99ac790b9bbbe38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FlatIconEdit = {
  flatId: string;
  url: string;
};
export type cardCreateMutation$variables = {
  back: string;
  deckId: string;
  deleted?: boolean | null;
  front: string;
  hint?: string | null;
  langBack?: string | null;
  returnDeck?: boolean | null;
  sBackId?: string | null;
  sCardId?: string | null;
  sourceId?: string | null;
  svg?: FlatIconEdit | null;
};
export type cardCreateMutation$data = {
  readonly cardCreate: {
    readonly deck: {
      readonly id: string;
      readonly stats: {
        readonly completed: number;
        readonly known: number;
        readonly total: number;
        readonly unknown: number;
      };
    } | null;
    readonly duplicatedCard: {
      readonly back: string;
      readonly front: string;
      readonly id: string;
    } | null;
  } | null;
};
export type cardCreateMutation = {
  response: cardCreateMutation$data;
  variables: cardCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "back"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deckId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deleted"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "front"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hint"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "langBack"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "returnDeck"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sBackId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sCardId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "svg"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "back",
        "variableName": "back"
      },
      {
        "kind": "Variable",
        "name": "deckId",
        "variableName": "deckId"
      },
      {
        "kind": "Variable",
        "name": "deleted",
        "variableName": "deleted"
      },
      {
        "kind": "Variable",
        "name": "front",
        "variableName": "front"
      },
      {
        "kind": "Variable",
        "name": "hint",
        "variableName": "hint"
      },
      {
        "kind": "Variable",
        "name": "langBack",
        "variableName": "langBack"
      },
      {
        "kind": "Variable",
        "name": "returnDeck",
        "variableName": "returnDeck"
      },
      {
        "kind": "Variable",
        "name": "sBackId",
        "variableName": "sBackId"
      },
      {
        "kind": "Variable",
        "name": "sCardId",
        "variableName": "sCardId"
      },
      {
        "kind": "Variable",
        "name": "sourceId",
        "variableName": "sourceId"
      },
      {
        "kind": "Variable",
        "name": "svg",
        "variableName": "svg"
      }
    ],
    "concreteType": "CardReturnType",
    "kind": "LinkedField",
    "name": "cardCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Card",
        "kind": "LinkedField",
        "name": "duplicatedCard",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "front",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "back",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Deck",
        "kind": "LinkedField",
        "name": "deck",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Stats",
            "kind": "LinkedField",
            "name": "stats",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "total",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "known",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unknown",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "completed",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "cardCreateMutation",
    "selections": (v12/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v2/*: any*/),
      (v10/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "cardCreateMutation",
    "selections": (v12/*: any*/)
  },
  "params": {
    "cacheID": "65cf72177f1434891813b5c4878fe639",
    "id": null,
    "metadata": {},
    "name": "cardCreateMutation",
    "operationKind": "mutation",
    "text": "mutation cardCreateMutation(\n  $deckId: ID!\n  $front: String!\n  $back: String!\n  $langBack: String\n  $hint: String\n  $sCardId: ID\n  $sBackId: ID\n  $sourceId: ID\n  $deleted: Boolean\n  $svg: FlatIconEdit\n  $returnDeck: Boolean\n) {\n  cardCreate(deckId: $deckId, front: $front, back: $back, langBack: $langBack, hint: $hint, sCardId: $sCardId, sBackId: $sBackId, sourceId: $sourceId, deleted: $deleted, returnDeck: $returnDeck, svg: $svg) {\n    duplicatedCard {\n      id\n      front\n      back\n    }\n    deck {\n      id\n      stats {\n        total\n        known\n        unknown\n        completed\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "db59436499b7c8f1583440471998c108";

export default node;
